module.exports = __webpack_public_path__ + "img/edit.6a0f1377.svg";